export const PROFIT_STATUS_ITEMS = [
  { label: '全て', value: '' },
  { label: '入社待ち', value: 'waiting_entry' },
  { label: '請求書送付済み', value: 'invoice_sent' },
  { label: '入金待ち', value: 'waiting_payment' },
  { label: '支払い済み', value: 'paid' },
  { label: '返金予定', value: 'refund' },
  { label: '返金済み', value: 'refunded' },
  { label: '候補者辞退', value: 'candidate_declined' },
  { label: '企業NG', value: 'company_declined' },
  { label: '削除済', value: 'deleted' },
] as const;

export const PROFIT_STATUS_COLOR_MAP: Record<string, string> = {
  waiting_entry: 'secondary',
  invoice_sent: 'secondary',
  waiting_payment: 'secondary',
  paid: 'success',
  candidate_declined: 'warning',
  company_declined: 'warning',
  refund: 'danger',
  refunded: 'danger',
  deleted: 'danger',
};

export const PROFIT_SORT_ITEMS = [
  { label: '最終更新順', value: 'updated_at' },
  { label: '売上金額順', value: 'profit_value' },
  { label: '入社予定日順', value: 'entry_expect_date' },
  { label: '作成日順', value: 'created_at' },
] as const;
